import { Injectable } from '@angular/core';
import { PowerBIConfig } from '../interfaces/powerbi-config.interface';

declare var powerbi: any;

@Injectable({
  providedIn: 'root'
})
export class PowerBIService {

  constructor() { }

  /**
   * Configura e carrega um relatório PowerBI
   */
  loadReport(embeddedReport: any, config: PowerBIConfig): void {
    if (embeddedReport && config) {
      const report = powerbi.embed(embeddedReport, config);
      
      // Adiciona event listeners
      report.on('loaded', () => {
        console.log('PowerBI Report loaded');
      });

      report.on('error', (error: any) => {
        console.error('PowerBI Report error:', error);
      });
    }
  }

  /**
   * Cria configuração padrão para PowerBI
   */
  createConfig(embedUrl: string, accessToken: string, reportId: string): PowerBIConfig {
    return {
      type: 'report',
      embedUrl: embedUrl,
      accessToken: accessToken,
      id: reportId,
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true
      }
    };
  }

  /**
   * Limpa o relatório PowerBI
   */
  clearReport(embeddedReport: any): void {
    if (embeddedReport) {
      powerbi.reset(embeddedReport);
    }
  }

  /**
   * Atualiza o token de acesso
   */
  updateAccessToken(embeddedReport: any, newToken: string): void {
    if (embeddedReport) {
      powerbi.updateAccessToken(embeddedReport, newToken);
    }
  }
}
